import { gql, useQuery } from "@apollo/client";

const FETCH_BANNERS = gql`
query getBanners {
  banners(order_by: {createdAt: Asc}) {
    badge
    imageUrl
    description
    id
    primaryLink
    primaryText
    secondaryLink
    secondaryText
    title
    variant
  }
}
`;

export function useBanners() {
  const { data, loading, error, refetch } = useQuery(FETCH_BANNERS, {
    context: {
      headers: {
        'x-hasura-role': 'learner',
      },
    }
  }
  );

  return { data, loading, error, refetch };
}
